import { motion } from 'framer-motion';

export const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen">
      <section className="pt-32 pb-20 px-4 bg-gradient-to-br from-primary/5 via-background to-secondary/5">
        <div className="max-w-4xl mx-auto">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <h1 className="text-4xl sm:text-5xl font-bold text-foreground mb-6">Privacy Policy</h1>
            <p className="text-lg text-muted-foreground">Last updated: January 2026</p>
          </motion.div>
        </div>
      </section>

      <section className="py-20 px-4 bg-background">
        <div className="max-w-4xl mx-auto space-y-12">
          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">1. Introduction</h2>
            <p className="text-muted-foreground leading-relaxed">
              Trademark Assist is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">2. Information We Collect</h2>
            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p><strong>Personal Information:</strong> We may collect personal information such as your name, email address, phone number, and business details when you:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Register for our services</li>
                <li>Submit trademark applications</li>
                <li>Contact us through forms or email</li>
                <li>Subscribe to our newsletter</li>
              </ul>
              <p className="mt-4"><strong>Usage Data:</strong> We automatically collect information about your device and how you interact with our website, including IP address, browser type, pages visited, and time spent on pages.</p>
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">3. How We Use Your Information</h2>
            <div className="text-muted-foreground leading-relaxed">
              <p className="mb-3">We use the information we collect to:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Process trademark applications and provide our services</li>
                <li>Communicate with you about your applications and services</li>
                <li>Send administrative information and service updates</li>
                <li>Respond to your inquiries and provide customer support</li>
                <li>Improve our website and services</li>
                <li>Comply with legal obligations</li>
              </ul>
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">4. Information Sharing and Disclosure</h2>
            <div className="text-muted-foreground leading-relaxed">
              <p className="mb-3">We may share your information with:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li><strong>Government Agencies:</strong> UK Intellectual Property Office and other relevant authorities for trademark registration</li>
                <li><strong>Service Providers:</strong> Third-party vendors who assist us in providing our services</li>
                <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
              </ul>
              <p className="mt-4">We do not sell, rent, or trade your personal information to third parties for marketing purposes.</p>
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">5. Data Security</h2>
            <p className="text-muted-foreground leading-relaxed">
              We implement appropriate technical and organizational security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">6. Your Rights</h2>
            <div className="text-muted-foreground leading-relaxed">
              <p className="mb-3">Under UK data protection laws, you have the right to:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Access your personal information</li>
                <li>Correct inaccurate information</li>
                <li>Request deletion of your information</li>
                <li>Object to processing of your information</li>
                <li>Request restriction of processing</li>
                <li>Data portability</li>
              </ul>
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">7. Cookies</h2>
            <p className="text-muted-foreground leading-relaxed">
              Our website uses cookies to enhance your browsing experience. You can control cookie preferences through your browser settings. However, disabling cookies may affect website functionality.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">8. Third-Party Links</h2>
            <p className="text-muted-foreground leading-relaxed">
              Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites. We encourage you to review their privacy policies.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">9. Children's Privacy</h2>
            <p className="text-muted-foreground leading-relaxed">
              Our services are not directed to individuals under 18 years of age. We do not knowingly collect personal information from children.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">10. Changes to This Policy</h2>
            <p className="text-muted-foreground leading-relaxed">
              We may update this Privacy Policy periodically. We will notify you of any material changes by posting the new policy on this page with an updated revision date.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">11. Contact Us</h2>
            <div className="text-muted-foreground leading-relaxed">
              <p className="mb-3">If you have questions about this Privacy Policy, please contact us:</p>
              <ul className="space-y-2">
                <li>Email: info@trademarkassist.co.uk</li>
                <li>Phone: +44 20 1234 5678</li>
                <li>Address: London, United Kingdom</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
